"use strict";
/* globals window */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var instances = {};
var create = function (baseURL, authToken) {
    var instanceId = baseURL;
    if (typeof instances[instanceId] !== 'undefined')
        return instances[instanceId];
    var api = apisauce_1.default.create({
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: "Bearer ".concat(authToken)
        },
        timeout: 20000
    });
    var createCardToken = function (fullName, cardNumber, expirationMonth, expirationYear, cvc) {
        var urlEncodedBody = "card[name]=".concat(encodeURIComponent(fullName), "&card[number]=").concat(cardNumber, "&card[exp_month]=").concat(expirationMonth, "&card[exp_year]=").concat(expirationYear, "&card[cvc]=").concat(cvc);
        return api.post('/tokens', urlEncodedBody).then(function (response) {
            if (response.ok && response.data.id) {
                return response.data.id;
            }
            else {
                throw response.data;
            }
        });
    };
    instances[instanceId] = {
        createCardToken: createCardToken
    };
    return instances[instanceId];
};
exports.default = {
    create: create
};
